import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import ContactSalesButton from "./ContactSalesButton";

interface EnterpriseTierProps {
  onContactSales: () => void;
}

const EnterpriseTier = ({ onContactSales }: EnterpriseTierProps) => {
  return (
    <div className="mt-16 rounded-lg border bg-card text-card-foreground shadow-sm max-w-4xl mx-auto">
      <div className="grid md:grid-cols-2">
        <div className="p-8">
          <h3 className="text-2xl font-bold mb-2">Enterprise</h3>
          <p className="text-muted-foreground mb-6">
            Tailored solutions for larger organizations with unique needs
          </p>
          <ul className="space-y-3 mb-6">
            <li className="flex items-center gap-2">
              <Check className="h-4 w-4 text-primary" />
              <span className="text-sm">Everything in Agency</span>
            </li>
            <li className="flex items-center gap-2">
              <Check className="h-4 w-4 text-primary" />
              <span className="text-sm">On-premise hosting options</span>
            </li>
            <li className="flex items-center gap-2">
              <Check className="h-4 w-4 text-primary" />
              <span className="text-sm">Custom AI model training</span>
            </li>
            <li className="flex items-center gap-2">
              <Check className="h-4 w-4 text-primary" />
              <span className="text-sm">Bulk campaign automation</span>
            </li>
            <li className="flex items-center gap-2">
              <Check className="h-4 w-4 text-primary" />
              <span className="text-sm">Auto-launch with new landing pages</span>
            </li>
            <li className="flex items-center gap-2">
              <Check className="h-4 w-4 text-primary" />
              <span className="text-sm">Team functions & collaboration</span>
            </li>
            <li className="flex items-center gap-2">
              <Check className="h-4 w-4 text-primary" />
              <span className="text-sm">Dedicated support & SLA</span>
            </li>
          </ul>
          <Link 
            to="/plans/enterprise"
            className="text-sm text-primary hover:underline"
          >
            Learn more about Enterprise →
          </Link>
        </div>
        <div className="p-8 flex flex-col items-start justify-center bg-muted/20 border-l">
          <h4 className="text-lg font-medium mb-2">Custom Pricing</h4>
          <p className="text-sm text-muted-foreground mb-6">
            Tailored to your organization's specific needs and requirements
          </p>
          <ContactSalesButton onClick={onContactSales} />
        </div>
      </div>
    </div>
  );
};

export default EnterpriseTier;